import { useSyncExternalStore } from "react";

/**
 * The palette showing right now, which always follows the OS.
 *
 * The palettes live in @bandwith/styles/theme.css as light-dark() colors, so
 * Tailwind classes and `themeColors` follow the OS without any code. Reach
 * for this hook only when colors must be literal values, such as SVG
 * presentation attributes.
 */
export type ColorScheme = "light" | "dark";

const DARK_QUERY = "(prefers-color-scheme: dark)";

function subscribe(listener: () => void): () => void {
  const media = window.matchMedia(DARK_QUERY);
  media.addEventListener("change", listener);
  return () => media.removeEventListener("change", listener);
}

function getSnapshot(): ColorScheme {
  return window.matchMedia(DARK_QUERY).matches ? "dark" : "light";
}

function getServerSnapshot(): ColorScheme {
  return "dark";
}

export function useColorScheme(): ColorScheme {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
